import * as React from "react";

function SvgStarO(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#star-o_svg__clip0_3182_29842)">
        <path
          d="M12 4.236l1.813 4.515.195.485.522.036 4.854.329-3.734 3.12-.401.335.127.507 1.187 4.718-4.12-2.587-.443-.278-.443.278-4.12 2.587 1.186-4.718.128-.507-.401-.336L4.616 9.6l4.854-.328.522-.036.195-.485L12 4.236z"
          stroke="currentColor"
          strokeWidth={1.667}
        />
      </g>
      <defs>
        <clipPath id="star-o_svg__clip0_3182_29842">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgStarO;
